module.exports = __webpack_public_path__ + "img/avatar1.cc232dc5.png";